export default {
  withdraw: {
    title: 'رقم نکالیں',
    subtitle: 'تیز، محفوظ اور آسان',
    secureEncrypted: 'محفوظ اور خفیہ کردہ',
    fiatOrCash: 'فیاٹ/نقد',
    processing: 'کارروائی جاری ہے...',
    select: 'منتخب کریں',
    withdrawCurrency: 'رقم نکالنے کی کرنسی',
    chooseNetwork: 'نیٹ ورک منتخب کریں',
    channel: 'چینل',
    withdrawalAddress: 'نکالنے کا پتہ',
    pixKeyType: 'PIX کی قسم',
    accountNumber: 'اکاؤنٹ نمبر',
    enterAccountNumber: 'اپنا اکاؤنٹ نمبر درج کریں',
    accountName: 'اکاؤنٹ کا نام',
    enterAccountName: 'اکاؤنٹ ہولڈر کا نام درج کریں',
    pixKey: 'PIX کلید',
    enterPixKey: 'اپنی PIX کلید درج کریں',
    cpf: 'CPF',
    enterCpf: 'CPF درج کریں',
    bankName: 'بینک کا نام',
    enterBankName: 'بینک کا نام درج کریں',
    branch: 'برانچ',
    enterBranch: 'برانچ درج کریں (اختیاری)',
    phone: 'فون',
    enterPhone: 'فون درج کریں (اختیاری)',
    email: 'ای میل',
    enterEmail: 'ای میل درج کریں (اختیاری)',
    available: 'قابلِ نکاسی',
    amountPlaceholder: 'رقم ({unit})',
    min: 'کم از کم',
    max: 'زیادہ سے زیادہ',
    totalWithdrawalAmount: 'کل نکالی جانے والی رقم:',
    fee: 'فیس:',
    withdrawalAmount: 'نکالی جانے والی رقم:',
    fundsSafeTitle: 'آپ کی رقم ہمارے پاس محفوظ ہے',
    fundsSafeDesc: 'ہم آپ کے لین دین اور ذاتی معلومات کے تحفظ کے لیے صنعت کی بہترین سیکیورٹی استعمال کرتے ہیں۔',
    enterWithdrawalAddress: 'براہ کرم نکالنے کا پتہ درج کریں',
    enterAccountNumberRequired: 'براہ کرم اپنا اکاؤنٹ نمبر درج کریں',
    selectChannelRequired: 'براہ کرم ایک چینل منتخب کریں',
    enterAccountNameRequired: 'براہ کرم اکاؤنٹ ہولڈر کا نام درج کریں',
    selectPixKeyTypeRequired: 'براہ کرم PIX کی قسم منتخب کریں',
    enterCpfRequired: 'براہ کرم CPF درج کریں',
    enterValidAmount: 'براہ کرم درست رقم درج کریں',
    minWithdrawal: 'کم از کم نکالی جانے والی رقم: {amount} {unit}',
    maxWithdrawal: 'زیادہ سے زیادہ نکالی جانے والی رقم: {amount} {unit}',
    insufficientBalance: 'دستیاب بیلنس ناکافی ہے',
    withdrawalRejected: 'رقم نکالنے کی درخواست مسترد کر دی گئی',
    submittedPendingReview: 'درخواست جمع کرا دی گئی، جائزے کے انتظار میں',
    submittedPayoutInProgress: 'درخواست جمع کرا دی گئی، ادائیگی جاری ہے',
    withdrawalFailed: 'رقم نکالنا ناکام',
    withdrawalFailedRetry: 'رقم نکالنا ناکام، براہ کرم دوبارہ کوشش کریں',
  },
};
